'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentType = exports.AmlStatus = void 0;
var AmlStatus;
(function (AmlStatus) {
    AmlStatus["PROCESSING"] = "Processing";
    AmlStatus["PENDING"] = "Pending";
    AmlStatus["NOT_SET"] = "NotSet";
    AmlStatus["REQUESTED"] = "Requested";
    AmlStatus["REJECTED"] = "Rejected";
    AmlStatus["USER_REQUESTED"] = "UserRequested";
    AmlStatus["APPROVED"] = "Approved";
    AmlStatus["PENDING_REQUEST"] = "PendingRequest";
    // only used for CoreX
    AmlStatus["VERIFIED_PARTIAL"] = "VerifiedPartial";
    AmlStatus["EXPIRED"] = "Expired";
})(AmlStatus = exports.AmlStatus || (exports.AmlStatus = {}));
var DocumentType;
(function (DocumentType) {
    DocumentType["PHOTO_ID"] = "photoID";
    DocumentType["ADDRESS"] = "address";
    DocumentType["PAYMENT"] = "payment";
    DocumentType["SOURCE_OF_WEALTH"] = "SOWQ";
    DocumentType["SOURCE_OF_WEALTH_DOCUMENTS"] = "SOWD";
    DocumentType["SOURCE_OF_FUNDS"] = "SOF";
})(DocumentType = exports.DocumentType || (exports.DocumentType = {}));
